<form [formGroup]="contentForm" class="form-container">
  <h1 class="header">Content Upload</h1>
  <div class="row">
    <mat-form-field class="col-6">
      <mat-label>Unit</mat-label>
      <input
        type="text"
        [placeholder]="'Unit'"
        matInput
        [matAutocomplete]="autoUnit"
        formControlName="unit"
      />
      <mat-autocomplete
        #autoUnit="matAutocomplete"
        (optionSelected)="changeUnitSelection($event)"
        [displayWith]="displayFn"
      >
        @for (opt of units; track opt.value) {
          <mat-option [value]="opt">
            {{ opt.value }}: {{ opt.display }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="col-6">
      <mat-label>Content Type</mat-label>
      <mat-select formControlName="contentType">
        @for (type of contentTypes; track $index) {
          <mat-option [value]="type.value">
            {{ type.name }}
          </mat-option>
        }
      </mat-select>
      <mat-error>Content Type is required</mat-error>
    </mat-form-field>
  </div>

  @if (contentForm.get('contentType').value === 'AiPrompt') {
    <div class="row">
      <mat-form-field class="col-6">
        <mat-label>Name</mat-label>
        <mat-select formControlName="name">
          @for (name of names; track $index) {
            <mat-option [value]="name.value">
              {{ name.name }}
            </mat-option>
          }
        </mat-select>
        <mat-error>Name is required</mat-error>
      </mat-form-field>
    </div>
  }

  <div class="row">
    <mat-form-field class="col-12">
      <mat-label>Content</mat-label>
      <textarea
        matInput
        rows="7"
        formControlName="content"
        placeholder="Enter content here"
      ></textarea>
      <mat-error>Content is required</mat-error>
    </mat-form-field>
  </div>

  <div class="">
    <button
      class="me-2"
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="!contentForm.valid || !selectedUnit"
    >
      <mat-icon>save</mat-icon> Save
    </button>
    <button class="me-2" mat-button color="warn" (click)="onReset()">
      <mat-icon>replay</mat-icon>Clear
    </button>
    <!-- file reader future feature. commenting out for now to get a good first version done for now. -->
    <!-- <input
      type="file"
      (change)="onFileSelected($event)"
      accept=".json,.txt,.csv"
    /> -->
  </div>
</form>
